import { Plugins } from '@capacitor/core';
import { Schedule, Session } from '../models/Schedule';
import { Speaker } from '../models/Speaker';
import { Location } from '../models/Location';

const { Storage } = Plugins;

const dataUrl = '/assets/data/data.json';
const locationsUrl = '/assets/data/locations.json';

const HAS_LOGGED_IN = 'hasLoggedIn';
const HAS_SEEN_TUTORIAL = 'hasSeenTutorial';
const USERNAME = 'username';
const USERDATA = 'userdata';
const USERTOKEN = 'usertoken';
export const getConfData = async () => {
  const response = await Promise.all([
    fetch(dataUrl),
    fetch(locationsUrl)]);
  const responseData = await response[0].json();
  const schedule = responseData.schedule[0] as Schedule;
  const sessions = parseSessions(schedule);
  const speakers = responseData.speakers as Speaker[];
  const locations = await response[1].json() as Location[];
  const allTracks = sessions
    .reduce((all, session) => all.concat(session.tracks), [] as string[])
    .filter((trackName, index, array) => array.indexOf(trackName) === index)
    .sort();

  const data = {
    schedule,
    sessions,
    locations,
    speakers,
    allTracks,
    filteredTracks: [...allTracks]
  }
  return data;
}

export const getUserToken = async () => {
  const response = await Promise.all([
    
    Storage.get({ key: USERTOKEN })
  ]);
  const usertoken:any = await response[0].value|| undefined;
  let result:any = usertoken
  if(usertoken){
    result = JSON.parse(usertoken);
  }
  return result;
}
export const getUserData = async () => {
  const response = await Promise.all([
    Storage.get({ key: HAS_LOGGED_IN }),
    Storage.get({ key: HAS_SEEN_TUTORIAL }),
    Storage.get({ key: USERDATA }),
    Storage.get({ key: USERNAME }),
    Storage.get({ key: USERTOKEN })
  ]);
  const isLoggedin = await response[0].value === 'true';
  const hasSeenTutorial = await response[1].value === 'true';
  const userdata = await response[2].value || undefined;
  const username = await response[3].value || undefined;
  const usertoken = await response[4].value || undefined;
  const data = {
    isLoggedin,
    hasSeenTutorial,
    username,
    userdata,
    usertoken
  }
  return data;
}

export const setIsLoggedInData = async (isLoggedIn: boolean) => {
  if(isLoggedIn===false){
    await Storage.remove({ key: USERDATA });
    await Storage.remove({ key: USERTOKEN });
  }
  await Storage.set({ key: HAS_LOGGED_IN, value: JSON.stringify(isLoggedIn) });
}

export const setHasSeenTutorialData = async (hasSeenTutorial: boolean) => {
  await Storage.set({ key: HAS_SEEN_TUTORIAL, value: JSON.stringify(hasSeenTutorial) });
}

export const setUsernameData = async (username?: string) => {
  if (!username) {
    await Storage.remove({ key: USERNAME });
  } else {
    await Storage.set({ key: USERNAME, value: username });
  }
}

export const setUserdataData = async (userdata?: any) => {
  if (!userdata) {
    await Storage.remove({ key: USERDATA });
  } else {
    await Storage.set({ key: USERDATA, value: JSON.stringify(userdata) });
  }
}

export const setUsertokenData = async (usertoken?: any) => {
  if (!usertoken) {
    await Storage.remove({ key: USERTOKEN });
  } else {
    await Storage.set({ key: USERTOKEN, value: JSON.stringify(usertoken) });
  }
}
function parseSessions(schedule: Schedule) {
  const sessions: Session[] = [];
  schedule.groups.forEach(g => {
    g.sessions.forEach(s => sessions.push(s))
  });
  return sessions;
}
